// Catalog.ID Client — OIDC API
// ============================================================================

import { api } from './client';
import type {
    OidcAuthorizationDetails,
    OidcApproveRequest, OidcApproveResponse, OidcDenyResponse,
    OidcConsentSummary,
    UpdateConsentRequest,
} from './types';

export async function getAuthorizationDetails(requestId: string): Promise<OidcAuthorizationDetails> {
    return api.get(`/api/oidc/authorize/${requestId}`);
}

export async function approveAuthorization(requestId: string, req: OidcApproveRequest): Promise<OidcApproveResponse> {
    return api.post(`/api/oidc/authorize/${requestId}/approve`, req);
}

export async function denyAuthorization(requestId: string): Promise<OidcDenyResponse> {
    return api.post(`/api/oidc/authorize/${requestId}/deny`);
}

export async function listConsents(): Promise<OidcConsentSummary[]> {
    return api.get('/api/oidc/consents');
}

export async function revokeConsent(id: number): Promise<void> {
    return api.del(`/api/oidc/consents/${id}`);
}

export async function updateConsent(id: number, req: UpdateConsentRequest): Promise<void> {
    return api.put(`/api/oidc/consents/${id}`, req);
}
